/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function($) {

    $(document).ready(function(){
      $('.testimonials-slider').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 7000,
        adaptiveHeight: true
      });
    });
    // Add custom code below this line
  

  })(jQuery);
  
  (function () {
  
  const tabs = document.querySelectorAll('.tab-link');
  const tabContents = document.querySelectorAll('.product-tab-content');
  
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      // Remove active class from all tabs and contents
      tabs.forEach(t => t.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
  
      // Add active class to clicked tab and corresponding content
      this.classList.add('active');
      document.getElementById(this.getAttribute('data-tab')).classList.add('active');
    });
  });
  
  
   // Select all elements with the class 'variant-title'
  const variantElements = document.querySelectorAll('.variant-title');
  
  variantElements.forEach(function (element) {
      // Get the variant title and price from data attributes
      let title = element.getAttribute('data-title').trim();
      const price = element.getAttribute('data-price');
      
      // Clean up title by removing unwanted characters and extra spaces
      title = title.replace(/[^a-zA-Z0-9:/\s]/g, '').replace(/\s+/g, ' ').trim();
  
      // Regular expression to detect the date in format MM/DD/YYYY
      const datePattern = /(\d{1,2}\/\d{1,2}\/\d{4})/;
      // Regular expression to detect the time in 12-hour format
      const timePattern = /(\d{1,2}:\d{2}\s?(AM|PM))/gi;
  
      // Extract date
      const dateMatch = title.match(datePattern);
      let dateString = 'Date: Not available';
      if (dateMatch && dateMatch[0]) {
          // Convert date to word format
          const dateParts = dateMatch[0].split('/');
          const month = parseInt(dateParts[0], 10);
          const day = dateParts[1];
          const year = dateParts[2];
  
          // Array of month names
          const monthNames = [
              'January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'
          ];
          dateString = `Date: ${monthNames[month - 1]} ${day}, ${year}`;
      }
  
      // Extract times
      const timeMatches = title.match(timePattern);
      let timeString = 'Time: Not available';
      if (timeMatches && timeMatches.length === 2) {
          timeString = `Time: From: ${timeMatches[0].toLowerCase()} - ${timeMatches[1].toLowerCase()}`;
      }
  
      // Update the content of the element with the formatted date, time, and price
      element.innerHTML = `${dateString}<br>${timeString}<br>Price: ${price}`;
   });
  })();
  